import { kngApi } from 'yxt-biz-pc/packages/api';

export default {
  // 获取知识新目录树
  getKngTreeNew(orgId, bodyParams) {
    return kngApi.post(`classificate/share/list/${orgId}`, bodyParams);
  }
};
